'use strict';let

DistributionParameters=class DistributionParameters{
constructor(binSize,firstBinStart,lastBinStart){
this._binSize=binSize;
this._firstBinStart=firstBinStart;
this._lastBinStart=lastBinStart;
}

get binSize(){
return this._binSize;
}

get firstBinStart(){
return this._firstBinStart;
}

get lastBinStart(){
return this._lastBinStart;
}

get totalBins(){
return(this._lastBinStart-this._firstBinStart)/this._binSize+1;
}

checkDistributionsConformity(distribution){
if(distribution.binSize!==this._binSize){
throw new Error('Bin size mismatch');
}

if(distribution.start!==this._firstBinStart){
throw new Error('Distribution start mismatch');
}

if(distribution.bins.length!==this.totalBins){
throw new Error('Distribution end mismatch');
}
}

static get DefaultFatigueDistributionParameters(){
return DefaultFatigueDistributionParameters;
}};


const DefaultFatigueDistributionParameters=new DistributionParameters(1,3,20);

module.exports=DistributionParameters;
//# sourceMappingURL=distributionParameters.js.map
